import React, { useRef } from "react";
import { Table } from "react-bootstrap";
import { DownloadTableExcel } from "react-export-table-to-excel";

const GrossSalarySheetExport = ({
  reportData,
  TotalBasicPay,
  TotalIncrement,
  TotalBSAllow,
  TotalAdpAllow,
  TotalAdditional,
  TotalExtraPeriod,
  Total2ndShift,
  TotalDPTAllow,
  TotalCollege,
  TotalHostel,
  TotalInvDuty,
  TotalNavttc,
  TotalConva,
  TotalInterAllow,
  TotalGrossSalary,
  // TotalAnnualIncr,
}) => {
  const tableRef = useRef(null);

  return (
    <>
      <DownloadTableExcel
        filename="Gross Salary Sheet"
        sheet="Gross Salary Sheet"
        currentTableRef={tableRef.current}
      >
        <button className="btn btn-primary mx-2 mt-9">Export</button>
      </DownloadTableExcel>
      <div id="tableboot mt-5">
        <Table ref={tableRef} style={{ display: "none" }}>
          <thead>
            <tr id="tbl">
              <th className="text-center">Sr.No</th>
              <th className="text-center">Code</th>
              <th className="text-center">Name</th>
              <th className="text-center">Designation</th>
              <th className="text-center">Account No.</th>
              <th className="text-center">Pay Scale</th>
              <th className="text-center">Basic Pay</th>
              <th className="text-center">Increment Total</th>
              <th className="text-center">BS Allowance</th>
              <th className="text-center">ADP Allowance</th>
              <th className="text-center">Additional Allowance</th>
              <th className="text-center">Extra Period Allowance</th>
              <th className="text-center">2nd Shift Allowance</th>
              <th className="text-center">DPT Allowance</th>
              <th className="text-center">College Allowance</th>
              <th className="text-center">Hostel Allowance</th>
              <th className="text-center">Invigilator Duty Allowance</th>
              <th className="text-center">Navttc Allowance</th>
              <th className="text-center">Conv Allow</th>
              <th className="text-center">Intermediate Allowance</th>
              <th className="text-center">Gross Salary</th>
              {/* <th className="text-center">Annual Increment</th> */}
            </tr>
          </thead>

          <tbody>
            {reportData.length > 0 &&
              reportData.map((subitem, index) => (
                <tr id="tbl" key={index}>
                  <td
                    style={{
                      color: "black",
                      backgroundColor: "white",
                    }}
                    className="text_align_center"
                  >
                    {index + 1}
                  </td>
                  <td
                    style={{
                      color: "black",
                      backgroundColor: "white",
                    }}
                    className="text_align_center"
                  >
                    {subitem.emp_code}
                  </td>
                  <td
                    style={{
                      color: "black",
                      backgroundColor: "white",
                    }}
                    className="text_align_center"
                  >
                    {subitem.full_name}
                  </td>

                  <td style={{ color: "black" }} className="text_align_center">
                    {subitem.designation?.name}
                  </td>

                  {subitem.account_no === null ? (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {"Not Define"}
                    </td>
                  ) : (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {subitem.account_no}
                    </td>
                  )}

                  {subitem.pay_scale === null ? (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {"----"}
                    </td>
                  ) : (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {subitem.pay_scale?.payscale}
                    </td>
                  )}

                  {subitem.pay_scale === null ? (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {0}
                    </td>
                  ) : (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {subitem.pay_scale?.basic}
                    </td>
                  )}

                  {subitem.salaryAlowance === null ? (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {0}
                    </td>
                  ) : (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {subitem.salaryAlowance?.increment}
                    </td>
                  )}

                  {subitem.salaryAlowance === null ? (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {0}
                    </td>
                  ) : (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {subitem.salaryAlowance?.bs_allowance}
                    </td>
                  )}

                  {subitem.salaryAlowance === null ? (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {0}
                    </td>
                  ) : (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {subitem.salaryAlowance?.adp_allowance}
                    </td>
                  )}

                  {subitem.salaryAlowance === null ? (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {0}
                    </td>
                  ) : (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {subitem.salaryAlowance?.additional_allowance}
                    </td>
                  )}

                  {subitem.salaryAlowance === null ? (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {0}
                    </td>
                  ) : (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {subitem.salaryAlowance?.extra_period}
                    </td>
                  )}

                  {subitem.salaryAlowance === null ? (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {0}
                    </td>
                  ) : (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {subitem.salaryAlowance?.second_shift}
                    </td>
                  )}

                  {subitem.salaryAlowance === null ? (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {0}
                    </td>
                  ) : (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {subitem.salaryAlowance?.dpt_allowance}
                    </td>
                  )}

                  {subitem.salaryAlowance === null ? (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {0}
                    </td>
                  ) : (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {subitem.salaryAlowance?.college}
                    </td>
                  )}

                  {subitem.salaryAlowance === null ? (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {0}
                    </td>
                  ) : (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {subitem.salaryAlowance?.hostel}
                    </td>
                  )}

                  {subitem.salaryAlowance === null ? (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {0}
                    </td>
                  ) : (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {subitem.salaryAlowance?.invigilator_duty_allowance}
                    </td>
                  )}

                  {subitem.salaryAlowance === null ? (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {0}
                    </td>
                  ) : (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {subitem.salaryAlowance?.navttc_allowance}
                    </td>
                  )}

                  {subitem.salaryAlowance === null ? (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {0}
                    </td>
                  ) : (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {subitem.salaryAlowance?.convance}
                    </td>
                  )}

                  {subitem.salaryAlowance === null ? (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {0}
                    </td>
                  ) : (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {subitem.salaryAlowance?.intermediate_allowance}
                    </td>
                  )}

                  {subitem.pay_scale === null &&
                  subitem.salaryAlowance == null ? (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {"----"}
                    </td>
                  ) : (
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {parseInt(subitem.pay_scale?.basic) +
                        parseInt(subitem.salaryAlowance?.all_allowance_total)}
                    </td>
                  )}

                  {/* Annual Increment */}
                  {/* {subitem.pay_scale === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {0}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.pay_scale?.increment}
                        </td>
                      )} */}
                </tr>
              ))}
            <tr
              id="tbl"
              style={{
                //   fontWeight: "bold",
                backgroundColor: "gainsboro",
              }}
            >
              <td colSpan={6} className="text_align_center text-primary">
                Total
              </td>
              <td style={{ color: "black" }} className="text_align_center">
                {TotalBasicPay}
              </td>
              <td style={{ color: "black" }} className="text_align_center">
                {TotalIncrement}
              </td>
              <td style={{ color: "black" }} className="text_align_center">
                {TotalBSAllow}
              </td>
              <td style={{ color: "black" }} className="text_align_center">
                {TotalAdpAllow}
              </td>
              <td style={{ color: "black" }} className="text_align_center">
                {TotalAdditional}
              </td>
              <td style={{ color: "black" }} className="text_align_center">
                {TotalExtraPeriod}
              </td>
              <td style={{ color: "black" }} className="text_align_center">
                {Total2ndShift}
              </td>
              <td style={{ color: "black" }} className="text_align_center">
                {TotalDPTAllow}
              </td>
              <td style={{ color: "black" }} className="text_align_center">
                {TotalCollege}
              </td>
              <td style={{ color: "black" }} className="text_align_center">
                {TotalHostel}
              </td>
              <td style={{ color: "black" }} className="text_align_center">
                {TotalInvDuty}
              </td>
              <td style={{ color: "black" }} className="text_align_center">
                {TotalNavttc}
              </td>
              <td style={{ color: "black" }} className="text_align_center">
                {TotalConva}
              </td>
              <td style={{ color: "black" }} className="text_align_center">
                {TotalInterAllow}
              </td>
              <td style={{ color: "black" }} className="text_align_center">
                {TotalGrossSalary}
              </td>
              {/* <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {TotalAnnualIncr}
                    </td> */}
            </tr>
          </tbody>
        </Table>
        <div className="endTotalGlossNet" style={{ display: "none" }}>
          <div>
            <p>
              <b style={{ fontSize: "22px" }} className="text-primary">
                Total Gross Salary:
              </b>{" "}
              <b style={{ fontSize: "22px" }}>{TotalGrossSalary}</b>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default GrossSalarySheetExport;
